import api from '@/api/'
import _ from 'lodash'

export const strategyCommand = {
  edit(data) {
    this.title = title.Edit
    this.visible = true
    this.isEdit = true
    this.$nextTick(() => {
      this.form = _.cloneDeep(data)
      if (data.module_select) {
        this.form.modules = this.WORDS_MODULES.map(item => item.key)
        this.indeterminate = false
        this.checkAll = true
      } else {
        this.indeterminate = true
      }
    })
  },
  delete({ id }) {
    const _this = this
    this.$confirm({
      content: '确定要删除吗？',
      async onOk() {
        const res = await api.deleteTypeWord({ id })
        if (_this.$validate(res)) {
          _this.$message.success('删除成功~')
          _this.getList()
        }
      }
    })
  }
}

export const title = {
  Add: '添加违禁词分类',
  Edit: '编辑违禁词分类'
}
